import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";
import CommCard from "src/common/CommCard";
import { CommonPagination } from "src/common/CommonPagination";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import type { IVisitorInvoiceList } from "../type/visitorType";
import VisitorInvoiceTableRow from "./VisitorInvoiceTableRow";

const VisitorInvoiceList = () => {
	const [pagination, setPagination] = useState({
		limit: 50,
		skip: 0,
	});
	const [searchParams, setSearchParams] = useState({ name: "", status: "" });
	const { data, isLoading } = useGetQueryWithTotal<IVisitorInvoiceList[]>({
		endPoint: "/api/admin/visitor/invoice",
		queryKeys: ["visitor"],
		params: {
			...pagination,
			name: searchParams.name,
			status: searchParams.status,
		},
	});
	return (
		<CommCard
			showCardHeader
			helmetTitle='BTTF-Visitor Invoice'
			headerTitle={`Visitor Invoice List (${data?.total})`}
			handleSearchFun={(name) =>
				setSearchParams((prev) => ({ ...prev, name }))
			}
			showStatus
			showDateRange
			showSearch
			statusOptions={[
				{ id: "paid", name: "Paid" },
				{ id: "unpaid", name: "Unpaid" },
				{ id: "Partial Paid", name: "Partial Paid" },
			]}
			handleSelectStatus={(status) =>
				setSearchParams((prev) => ({ ...prev, status }))
			}
		>
			<TableContainer>
				<Table sx={{ position: "relative", minHeight: "250px" }}>
					<TableHead>
						<TableRow>
							<TableCell>SL.</TableCell>
							<TableCell>Date</TableCell>
							<TableCell>Invoice No.</TableCell>
							<TableCell>Organization</TableCell>
							<TableCell>Contact Name</TableCell>
							<TableCell>Email</TableCell>
							<TableCell>Amount</TableCell>
							<TableCell>Due</TableCell>
							<TableCell>Status</TableCell>
							<TableCell>Action</TableCell>
						</TableRow>
					</TableHead>

					{isLoading ? (
						<TableLoader />
					) : data?.data?.length ? (
						<TableBody>
							{data?.data?.map(
								(
									visitorInvoice: IVisitorInvoiceList,
									index
								) => {
									return (
										<VisitorInvoiceTableRow
											key={visitorInvoice.id}
											visitorInvoice={visitorInvoice}
											index={index + 1}
											paginationSkip={pagination.skip}
										/>
									);
								}
							)}
						</TableBody>
					) : (
						<TableNotFound />
					)}
				</Table>

				<Box p={2}>
					<CommonPagination
						total={data?.total}
						paginationCalFun={(limit: number, skip: number) => {
							setPagination({ limit, skip });
						}}
					/>
				</Box>
			</TableContainer>
		</CommCard>
	);
};

export default VisitorInvoiceList;
